import { Identifier, Questionnaire } from "@medplum/fhirtypes";

import { PRACTICE_QUESTIONNAIRE_URLS } from "@/fhir/constants/practice-questionnaire-urls";
import { Systems } from "@/fhir/enums/systems";

/**
 * Returns the identifier a QuestionnaireResponse carries so the shared Subscription for its
 * Questionnaire type matches it, whichever practice's copy of the Questionnaire it answers.
 * @param questionnaire - The Questionnaire being answered.
 * @returns `{ system: QH, value: questionnaire.url }` for a practice Questionnaire type, otherwise
 * `undefined`.
 */
export function getQuestionnaireTypeIdentifier(
  questionnaire: Questionnaire,
): Identifier | undefined {
  if (!questionnaire.url || !PRACTICE_QUESTIONNAIRE_URLS.has(questionnaire.url)) {
    return undefined;
  }
  return { system: Systems.QH, value: questionnaire.url };
}

/**
 * Returns the criteria of the shared Subscription in medplum.subscription.json that triggers the
 * bot for every response to a practice Questionnaire type.
 * @param questionnaireUrl - The canonical url of the practice Questionnaire type.
 * @returns `QuestionnaireResponse?identifier=<QH>|<url>`.
 */
export function getSharedQuestionnaireSubscriptionCriteria(questionnaireUrl: string): string {
  return `QuestionnaireResponse?identifier=${Systems.QH}|${questionnaireUrl}`;
}
